import { z } from '@repo/schema'
import {
  CommissionWithAssigneesSchema,
  GetCommissionAssigneeSchema,
  GetCommissionFieldSchema,
  GetCommissionRoleUsersSchema,
  SyncCommissionAssigneesBodySchema,
} from '@repo/schema/comissions'
import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'

const CommissionResponseSchema = z
  .object({ data: CommissionWithAssigneesSchema.nullable() })
  .transform(result => result.data)

export const createCommissionsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    // GET /commissions/fields
    fields: p
      .path('commissions', 'fields')
      .query(({ path, upFetch }) =>
        upFetch(path, { schema: getDataWrapperSchema(GetCommissionFieldSchema.array()) }),
      ),

    // GET /loads/:loadId/commission
    get: p
      .path(z.object({ loadId: z.number() }), p => ['loads', p.loadId, 'commission'])
      .query(({ path, upFetch }) => upFetch(path, { schema: CommissionResponseSchema })),

    // PATCH /loads/:loadId/commission/assignees
    syncAssignees: p
      .path(z.object({ loadId: z.number() }), p => ['loads', p.loadId, 'commission', 'assignees'])
      .input(SyncCommissionAssigneesBodySchema)
      .mutation(({ input, path, upFetch }) =>
        upFetch(path, {
          body: input,
          method: 'PATCH',
          schema: getDataWrapperSchema(GetCommissionAssigneeSchema.array()),
        }),
      ),

    // GET /commissions/users?filter[roles]=1,2,3
    users: p
      .path('commissions', 'users')
      .input(z.object({ 'filter[roles]': z.string() }))
      .query(({ input, path, upFetch }) =>
        upFetch(path, {
          params: input,
          schema: getDataWrapperSchema(GetCommissionRoleUsersSchema.array()),
        }),
      ),
  }
}
